import { useEffect, useState } from "react";
import CookieService from "../../services/CookieService";

/* eslint-disable no-undef */
const marketingCookiesDisabledPlaceholder = {
  nl: {
    label:
      "Omdat je de activatie van marketing cookies hebt geweigerd, kan je deze media-inhoud niet zien. Als je toch toegang wil tot de media-inhoud hoef je alleen deze cookies terug aan te zetten in",
    button: "je cookie voorkeursinstellingen",
  },
  fr: {
    label:
      "Comme vous avez refusé l'activation des cookies marketing, vous ne pouvez pas voir ce contenu média. Si vous souhaitez tout de même accéder à ce contenu, il vous suffit de réactiver ces cookies dans",
    button: "vos préférences en matière de cookies",
  },
  en: {
    label:
      "Because you have refused the activation of marketing cookies, you cannot see this media content. If you still want to access the media content, all you have to do is turn these cookies back on in",
    button: "your cookie preferences settings",
  },
};

const handleRenew = () => {
  Cookiebot.renew();
};

export const Message = () => {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    setLang(CookieService.get("DNSBELGIUM_LANGUAGE"));
  }, []);

  return (
    <div class="cookieconsent-message cookieconsent-optout-marketing">
      <p>
        {marketingCookiesDisabledPlaceholder[lang].label}{" "}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a onClick={handleRenew} className="underline-link">
          {marketingCookiesDisabledPlaceholder[lang].button}
        </a>
        .
      </p>
    </div>
  );
};
